import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AttachmentModel } from '@fc-vehicles/service/attachment-model';
import { getUserPhoto } from './get-user-photo';

@Component({
  selector: 'fc-user-photo',
  template: `
    <fc-image-loader
      [currentIndex]="0"
      [imageForm]="'circle'"
      [imagePlaceholder]="photoPlaceholder"
      [thumbHeight]="height"
      [thumbWidth]="width"
      [photoModels]="userPhotoModel"
      [placeholderSize]="'20px'"
      [notClickable]="!clickable"
    ></fc-image-loader>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UserPhotoComponent {
  @Input() employeePhoto: string | AttachmentModel;
  @Input() width: number;
  @Input() height: number;
  @Input() clickable: boolean;
  photoPlaceholder = '/assets/img/settings/settings-user-no-photo.svg';

  get userPhotoModel(): AttachmentModel[] {
    return getUserPhoto(this.employeePhoto);
  }
}
